import AircraftNavigation from "./components/AircraftNavigation.vue";
import RegulationsBrowse from "./views/RegulationsBrowse.vue";
import RegulationsCompare from "./views/RegulationsCompare.vue";

const sharedMeta = {
    app: "Regulations",
    fullBleed: true,
    security: "General.User",
};

const regulationMeta = {
    ...sharedMeta,
    sideNav: true,
    sideNavSection: "Regulations: Certification Specifications",
};

const notImplemented = () => [true, "not implemented"];

export default [
    // {
    //     path: "/Regulations",
    //     redirect: (to) => ({ name: "CS25", query: to.query }),
    // },
    {
        path: "/Regulations/CS23",
        name: "CS23",
        component: RegulationsBrowse,
        meta: {
            ...regulationMeta,
            name: "CS23",
            partNumber: "23",
            latestAmendment: 6,
            sideNavPosition: 0,
            appSwitcher: true,
            appSwitcherPosition: 10,
            icon: "book-bookmark",
            security: "Database.Read",
        },
    },
    {
        path: "/Regulations/CS25",
        name: "CS25",
        component: RegulationsBrowse,
        meta: {
            ...regulationMeta,
            name: "CS25",
            partNumber: "25",
            latestAmendment: 27,
            sideNavPosition: 1,
        },
    },
    {
        path: "/Regulations/CS27",
        name: "CS27",
        component: RegulationsBrowse,
        meta: {
            ...regulationMeta,
            name: "CS27",
            sideNavPosition: 2,
            lock: notImplemented,
        },
    },
    {
        path: "/Regulations/CS29",
        name: "CS29",
        component: RegulationsBrowse,
        meta: {
            ...regulationMeta,
            name: "CS29",
            sideNavPosition: 3,
            lock: notImplemented,
        },
    },
    {
        path: "/Regulations/Aircraft",
        name: "Aircraft TCDS Finder (Alpha)",
        component: AircraftNavigation,
        meta: {
            ...sharedMeta,
            name: "Aircraft TCDS Finder (Alpha)",
            sideNav: true,
            sideNavSection: "Regulation Tools",
            sideNavPosition: 0,
            icon: "plane",
        },
    },
    {
        path: "/Regulations/compare/:sectionKey/:type/:qualifier",
        name: "regulations-compare",
        component: RegulationsCompare,
        meta: {
            ...sharedMeta,
            name: "Compare Regulations",
        },
    },
];
